import { render, staticRenderFns } from "./BrutoPlates.vue?vue&type=template&id=614657a2&scoped=true"
import script from "./BrutoPlates.vue?vue&type=script&lang=js"
export * from "./BrutoPlates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614657a2",
  null
  
)

export default component.exports